import React from 'react'
import ReactDOM from 'react-dom'
// Templates
import Note from './templates/Note'

export default function DictationNote() {
  const mainText = `
  トレーニングの進め方を動画で確認しましょう。<br />
  「Dictation ＆ Overlapping」動画と「品詞判別トレーニング」動画は、以下の解説プリント／レジュメをあわせてご確認ください。
  `
  const textList = [
    {
      text: '●「主な音声変化まとめ」プリント（Dictation ＆ Overlapping 動画用）',
      fileName: '主な音声変化ルール_まとめプリント_STRAIL'
    },
    {
      text: '●「品詞判別」レジュメ（品詞判別トレーニング動画用）',
      fileName: '品詞判別レジュメ_STRAIL'
    }
  ]
  console.log(window.apiVideo.grammarCategories)
  return (
    <Note
      mainText={mainText}
      textList={textList}
    />
  )
}

if (document.getElementById('dictation')) {
  ReactDOM.render(
    <DictationNote />,
    document.getElementById('dictation')
  )
}